
import { Component } from "vue-property-decorator"
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import NotificationsButton from "@/components/New/Page/Notifications/NotificationsButton.vue"
import BaseNotificationMenu from "@/components/Notifications/BaseNotificationsMenu.vue"

@Component({
	components: {
		"notifications-button": NotificationsButton,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class NotificationsMenu extends BaseNotificationMenu {
}
